import type { ThunkDependencies } from "single-spa/store/thunk-dependencies";
import type { ThunkDispatchCommon, ThunkGetState } from "single-spa/store/types";

import type { SavedSearchDto } from "../types/dto";

import * as ac from "./action-creators";

/**
 * The API call to update existing saved search's name by given id
 * @param searchId
 * @param newName
 */
export function updateSavedSearchNameThunk(searchId: SavedSearchDto["searchId"], newName: SavedSearchDto["name"]) {
    return async function updateSavedSearchName(
        dispatch: ThunkDispatchCommon,
        _: ThunkGetState,
        deps: ThunkDependencies,
    ) {
        // Dispatching success before the actual request. Feel free to change if necessary.
        dispatch(ac.updateSavedSearchNameAsync.success({ searchId, name: newName }));

        try {
            await deps.si.api.advancedSearch.updateSearchNameById(searchId, newName);
            return newName;
        } catch {
            // we have a PUT request we do not want to handle fail for
        }
    };
}

/**
 * The API call to delete existing saved search by given `searchId`
 * @param searchId
 */
export function deleteSavedSearchThunk(searchId: SavedSearchDto["searchId"]) {
    return async function deleteSavedSearch(dispatch: ThunkDispatchCommon, _: ThunkGetState, deps: ThunkDependencies) {
        dispatch(ac.deleteSavedSearchAsync.request());

        try {
            await deps.si.api.advancedSearch.deleteSearchById(searchId);

            dispatch(ac.deleteSavedSearchAsync.success(searchId));
        } catch (e) {
            dispatch(ac.deleteSavedSearchAsync.failure(e?.message));
        }
    };
}

// TODO refactor search quota to be fetched & managed with react-query [SI-6591]
export const fetchSearchQuotaThunk =
    () => async (dispatch: ThunkDispatchCommon, _: ThunkGetState, deps: ThunkDependencies) => {
        dispatch(ac.fetchSearchQuota.request());

        try {
            const searchQuota = await deps.si.api.advancedSearch.fetchSearchQuota();

            dispatch(ac.fetchSearchQuota.success(searchQuota));
        } catch (e) {
            dispatch(ac.fetchSearchQuota.failure(e));
        }
    };
